module.exports = __webpack_public_path__ + "static/media/close.f3043184.svg";